import { Col, Row } from "@/utils/bootstrap";
import SvgCustomDropdownArrow from "./SvgCustomDropdownArrow";
interface Props {
  title: string;
  disabled: boolean;
}
const CustomDropdownTitle: React.FC<Props> = ({ title, disabled }) => {
  return (
    <Row className="w-100 m-0 d-flex align-items-center">
      <Col className="p-0 d-flex align-items-center col-auto">
        <div>{title}</div>
      </Col>
      <Col className="p-0 d-flex justify-content-end">
        <SvgCustomDropdownArrow disabled={disabled} />
      </Col>
    </Row>
  );
};

export default CustomDropdownTitle;
